import { useEffect, useState } from "react";
import { Form, Field, useFormikContext } from "formik";
import { Button, FormGroup, Label } from "reactstrap";
import { useSelector } from "react-redux";
import Loader from "../common/Loader/Loader";
import styles from "./Resource.module.scss";
import ReactSelect from "../common/Form/ReactSelect";

const UserRoleForm = (props) => {
    const [options, setOptions] = useState([]);
    const { setFieldValue } = useFormikContext();
    
    const enumData = useSelector((state) => state.resources.enumData);
    useEffect(() => {
        if (enumData && enumData?.role) {
            let op = [];
            for (const [key, value] of Object.entries(enumData?.role)) {
                op.push({ value: key, label: value });
            }
            setOptions(op);
        }
    }, [enumData]);

    useEffect(() => {
        if(props?.editedData){
            setFieldValue("role",String(props?.editedData?.role))
        }
    },[props?.editedData])
    return (
        <Form>
            <FormGroup className="form-group">
                <Field
                    name="role"
                    id="role"
                    placeholder="Select Role"
                    isMulti={false}
                    component={ReactSelect}
                    options={options}
                />
            </FormGroup>
            <Button type="submit" className={styles.brandButton}>
                {props?.loderPart ? (
                    <Loader height={30} width={30} color={"#FFFFFF"} />
                ) : (
                    "Save"
                )}
            </Button>
        </Form>
    );
};

export default UserRoleForm;
